/**
 * Canonicalises a Host header into the key used by the routing snapshot.
 *
 * The same function validates hostnames in the admin API, so a stored domain
 * and an inbound request can never disagree about what host they are.
 */
export function normalizeHost(hostHeader: string | undefined | null): string {
  if (hostHeader === undefined || hostHeader === null) return '';

  let value = hostHeader.trim().toLowerCase();
  if (value === '') return '';

  if (value.startsWith('[')) {
    const close = value.indexOf(']');
    if (close !== -1) return value.slice(0, close + 1);
    return value;
  }

  const colon = value.indexOf(':');
  if (colon !== -1) value = value.slice(0, colon);

  while (value.endsWith('.')) value = value.slice(0, -1);

  return value;
}
